/**
 * Convert any numeric-like value to number.
 * @param {number|string|object|null|undefined} value Numeric-like value to convert.
 * @returns {number} Converted numeric value, or 0 when conversion is not possible.
 */
const toNumber = value => {
    if (value === null || value === undefined)
        return 0

    if (typeof value === 'number')
        return value

    if (typeof value === 'string') {
        const cleaned = value.replace(',', '.')
        const n = Number(cleaned)
        return Number.isNaN(n) ? 0 : n
    }

    if (typeof value === 'object' && typeof value.toNumber === 'function')
        return value.toNumber()

    return 0
}

/**
 * Get the VAT rate of a client (tmsTvaAmount), used for its order quote pricing lines.
 * @param {{ tmsTvaAmount?: number|string|null }|null|undefined} client Client of the order quote.
 * @returns {number} VAT rate, 20 when there is no client or no rate.
 */
export const getClientVat = client => (
    client?.tmsTvaAmount === null || client?.tmsTvaAmount === undefined || client?.tmsTvaAmount === ''
        ? 20
        : toNumber(client.tmsTvaAmount)
)

const round2 = value => Math.round((value + Number.EPSILON) * 100) / 100

export const computeTotalHt = pricings =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pricings.reduce((acc, p) => {
        const unit = toNumber(p.costExcludingVat)
        const qty = toNumber(p.quantity)
        return round2(acc + unit * qty)
    }, 0)

export const computeTotalTtc = pricings =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pricings.reduce((acc, p) => {
        const unit = toNumber(p.costExcludingVat)
        const qty = toNumber(p.quantity)
        const vat = toNumber(p.vat)
        const ht = unit * qty
        const ttc = ht * (1 + vat / 100)
        return round2(acc + ttc)
    }, 0)
